<template>
  <div class="SanalPos">
    <h5> Manuel Sanal Pos</h5>
    <small>Onay mesajı ardından işlemlerinizi manuel olarak yapmanız gerekmektedir.</small>
    <hr>
    <el-input placeholder="Tahsil Edilecek Tutar" size="small" v-model="Odenecek" class="input-with-select">
      <el-button slot="append" @click="OdemeAl()" size="small" type="primary" icon="el-icon-bank-card"> 3D ile Ödeme Al
      </el-button>
    </el-input>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Odenecek: 0
      }
    },
    methods: {
      OdemeAl() {
        this.lo = true;
        this.$store.dispatch("Post", {Tutar: this.Odenecek, path: 'spesiyal/manuelpos/'})
          .then(response => {
            if (response.Durum === 'OK') {
              //this.OdemeModal = true;
              this.lo = false;
              this.Url = response.Link;
              window.open(this.Url, "MsgWindow", "toolbar=no,scrollbars=no,resizable=no,top=100,left=100,width=400,height=700");

            }
          });
      }
    }
  }
</script>

<style scoped>
  .SanalPos {
    padding: 10px;
  }

  .SanalPos h5 {
    font-size: 16px;
  }

  .SanalPos h6 {
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/ManuelSanalPos.vue